import * as actions from './letterTemplate/actions'
import * as mutations from './letterTemplate/mutations'
import * as getters from './letterTemplate/getters'

import { dataProps } from './letterTemplate/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/letterTemplate.js